import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CipRequestInterface } from '@interfaces';
import { environment } from '@src/environments';
import { Observable } from 'rxjs';

export interface ClearRequestPayload {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  decedentPoid: string;
  decedentId_private: string;
}

export interface ClearResponse {
  identityVerificationId?: string;
  result?: string;
  deathDate?: string;
  deceased: boolean;
  CNMKongToggle?: boolean;
}

export interface LegacyClearResponse {
  internalId?: string;
  clearResult?: string;
  entityIdentifier?: string;
  deathDate?: string;
  isDeceased: boolean;
  CNMKongToggle?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ClearService {
  constructor(private http: HttpClient) {}

  callExternalClientSearch(
    payload: ClearRequestPayload,
  ): Observable<ClearResponse | LegacyClearResponse> {
    return this.http.post<ClearResponse | LegacyClearResponse>(`secure/clear`, payload);
  }

  callCIPUpload(payload: CipRequestInterface): Observable<any> {
    return this.http.post<CipRequestInterface>(`secure/cip`, payload);
  }
}
